<div class="fix-action-dialog">
	<div class="fix-action-dialog">
		<h2 mat-dialog-title mat-dialog-title style="font-size: 14px;color:#ffffff;font-weight: 600;">Contact</h2>
	</div>

	<mat-dialog-content [class.dark-theme]="true">
		<mat-card>
			<mat-card-content>
				<div>{{content.username}}</div>

				<div *ngFor="let question of questions">{{question}}</div>

				<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
					<mat-form-field class="input-text">
						 <textarea
							 #answer="ngModel"
							 #autosize="cdkTextareaAutosize"
							 [(ngModel)]="content.answer"
							 cdkAutosizeMaxRows="5"
							 cdkAutosizeMinRows="1"
							 cdkTextareaAutosize
							 matInput
							 name="description"
							 placeholder="answer..."
							 type="text"
						 ></textarea>
					</mat-form-field>
				</form>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
		<mat-slide-toggle [(ngModel)]="resolve" [color]="'primary'" name="resolve" style="color:#fdfdfd;">Resolve</mat-slide-toggle>
		<button (click)="cancel()" color="warn" mat-dialog-close="" mat-raised-button id="mat-cancel-button">Cancel</button>
		<button (click)="onAccept()" [disabled]="form.invalid" cdkFocusInitial color="primary" mat-raised-button id="mat-ok-button">OK</button>
	</mat-dialog-actions>

</div>
